export default {"src":"/_next/static/media/shopping.4b52ff06.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};